import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgLoaderOutline = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_14560_158399)",
		children: [
			/* @__PURE__ */ _jsx("path", {
				d: "M12 2C11.7348 2 11.4804 2.10536 11.2929 2.29289C11.1054 2.48043 11 2.73478 11 3V5C11 5.26522 11.1054 5.51957 11.2929 5.70711C11.4804 5.89464 11.7348 6 12 6C12.2652 6 12.5196 5.89464 12.7071 5.70711C12.8946 5.51957 13 5.26522 13 5V3C13 2.73478 12.8946 2.48043 12.7071 2.29289C12.5196 2.10536 12.2652 2 12 2Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M21 11H19C18.7348 11 18.4804 11.1054 18.2929 11.2929C18.1054 11.4804 18 11.7348 18 12C18 12.2652 18.1054 12.5196 18.2929 12.7071C18.4804 12.8946 18.7348 13 19 13H21C21.2652 13 21.5196 12.8946 21.7071 12.7071C21.8946 12.5196 22 12.2652 22 12C22 11.7348 21.8946 11.4804 21.7071 11.2929C21.5196 11.1054 21.2652 11 21 11Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6 12C6 11.7348 5.89464 11.4804 5.70711 11.2929C5.51957 11.1054 5.26522 11 5 11H3C2.73478 11 2.48043 11.1054 2.29289 11.2929C2.10536 11.4804 2 11.7348 2 12C2 12.2652 2.10536 12.5196 2.29289 12.7071C2.48043 12.8946 2.73478 13 3 13H5C5.26522 13 5.51957 12.8946 5.70711 12.7071C5.89464 12.5196 6 12.2652 6 12Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.22023 5.00001C6.0253 4.81568 5.76512 4.71634 5.49695 4.72385C5.22877 4.73135 4.97456 4.84507 4.79023 5.04001C4.60591 5.23494 4.50657 5.49512 4.51407 5.76329C4.52157 6.03147 4.6353 6.28568 4.83023 6.47001L6.27023 7.86001C6.36687 7.95332 6.48131 8.0262 6.60673 8.07431C6.73215 8.12242 6.86598 8.14476 7.00023 8.14001C7.13494 8.13949 7.26815 8.11177 7.39187 8.0585C7.5156 8.00523 7.62728 7.92751 7.72023 7.83001C7.90648 7.64265 8.01102 7.38919 8.01102 7.12501C8.01102 6.86082 7.90648 6.60737 7.72023 6.42001L6.22023 5.00001Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.0001 8.13999C17.2576 8.13897 17.5047 8.03867 17.6901 7.85999L19.1301 6.46999C19.3058 6.28644 19.405 6.04291 19.4076 5.78886C19.4102 5.53481 19.316 5.28929 19.1442 5.10216C18.9723 4.91503 18.7357 4.80034 18.4824 4.78136C18.229 4.76238 17.9779 4.84055 17.7801 4.99999L16.3401 6.41999C16.1539 6.60735 16.0493 6.86081 16.0493 7.12499C16.0493 7.38918 16.1539 7.64263 16.3401 7.82999C16.5133 8.01271 16.7489 8.12341 17.0001 8.13999Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M12 18C11.7348 18 11.4804 18.1054 11.2929 18.2929C11.1054 18.4804 11 18.7348 11 19V21C11 21.2652 11.1054 21.5196 11.2929 21.7071C11.4804 21.8946 11.7348 22 12 22C12.2652 22 12.5196 21.8946 12.7071 21.7071C12.8946 21.5196 13 21.2652 13 21V19C13 18.7348 12.8946 18.4804 12.7071 18.2929C12.5196 18.1054 12.2652 18 12 18Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M17.7299 16.14C17.5389 15.9557 17.2826 15.8548 17.0172 15.8595C16.7518 15.8642 16.4992 15.9741 16.3149 16.165C16.1306 16.356 16.0296 16.6123 16.0343 16.8777C16.039 17.1431 16.1489 17.3957 16.3399 17.58L17.7799 19C17.9653 19.1787 18.2124 19.279 18.4699 19.28C18.6039 19.2808 18.7367 19.2547 18.8603 19.2031C18.984 19.1516 19.0961 19.0757 19.1899 18.98C19.2836 18.8871 19.358 18.7765 19.4088 18.6546C19.4596 18.5327 19.4857 18.402 19.4857 18.27C19.4857 18.138 19.4596 18.0073 19.4088 17.8855C19.358 17.7636 19.2836 17.653 19.1899 17.56L17.7299 16.14Z",
				fill: "black"
			}),
			/* @__PURE__ */ _jsx("path", {
				d: "M6.26998 16.14L4.82998 17.53C4.73625 17.623 4.66186 17.7336 4.61109 17.8554C4.56032 17.9773 4.53418 18.108 4.53418 18.24C4.53418 18.372 4.56032 18.5027 4.61109 18.6246C4.66186 18.7464 4.73625 18.857 4.82998 18.95C4.92377 19.0457 5.03584 19.1216 5.15952 19.1731C5.28321 19.2246 5.41599 19.2508 5.54998 19.25C5.79649 19.2521 6.03509 19.1631 6.21998 19L7.65998 17.61C7.85093 17.4257 7.96085 17.173 7.96553 16.9077C7.97022 16.6423 7.8693 16.3859 7.68498 16.195C7.50065 16.004 7.24802 15.8941 6.98266 15.8894C6.71729 15.8848 6.46093 15.9857 6.26998 16.17V16.14Z",
				fill: "black"
			})
		]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_14560_158399",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgLoaderOutline;
